import React, { createContext, useContext, useState, ReactNode } from 'react';
import { z } from 'zod';

// Input validation schema
const searchQuerySchema = z.string().trim().max(100, { message: "Search query must be less than 100 characters" });

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  validateAndSetQuery: (query: string) => boolean;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: { children: ReactNode }) => {
  const [searchQuery, setSearchQueryState] = useState('');

  const validateAndSetQuery = (query: string): boolean => {
    try {
      const validatedQuery = searchQuerySchema.parse(query);
      setSearchQueryState(validatedQuery);
      return true;
    } catch (error) {
      console.error('Invalid search query:', error);
      return false;
    }
  };

  const setSearchQuery = (query: string) => {
    setSearchQueryState(query);
  };

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery, validateAndSetQuery }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};
